import { defineField, defineType } from 'sanity'
import { richTextSimple } from '../../data/richText'
import extractTextFromRichText from '../../utils/extractFromRichText'

export default defineType({
  name: 'callToAction',
  title: 'Call to Action',
  type: 'object',
  fields: [
    defineField({
      name: 'heading',
      title: 'Heading',
      type: 'string',
    }),
    defineField({
      name: 'content',
      title: 'Content',
      type: 'array',
      of: richTextSimple,
      validation: (rule) => rule.required(),
    }),
    defineField({
      name: 'action',
      title: 'Action',
      type: 'link',
    }),
    defineField({
      name: 'theme',
      type: 'sectionTheme',
    }),
  ],
  preview: {
    select: {
      heading: 'heading',
      content: 'content',
    },
    prepare({ heading, content }) {
      const title = heading || extractTextFromRichText(content) || 'Call to Action'

      return {
        title,
        subtitle: 'Call to Action',
      }
    },
  },
})
